import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";

import {BathTubType} from "../bvComponent/core/constants";
import {changeQTRoutePath, changeRoutePath} from "../../misc/changeRoutePath";
import {getCurrentLayout} from "../appLayout";

export default class ProjectScopeFunctions extends Component {

  goToMaterialsPageCommon = (subPart, parentName) => {
    const layout = getCurrentLayout();
    let nextSubPartIndex = 0;
    // console.log('subPart', subPart);
    if (subPart.partId === "bathtub") {
      // console.log('subPart', subPart.getParent());
      subPart.getParent().handleSubTypeClick(BathTubType.FreeStanding)
    }
    const subPartName = subPart.partName.replace(/ /g,"-").toLowerCase();
    if (layout.qtCategories) {
      const qtCategory = layout.qtCategories.find(qtCategory => qtCategory.name === parentName);
      nextSubPartIndex = qtCategory.subParts.findIndex(subPartItem => {
        return subPartItem.part.partId === subPart.partId
      });
      this.props.setQtActiveCategory(parentName);
    } else if (subPart.getParent) {
      const subParts = subPart.getParent().subParts(false);
      nextSubPartIndex = subParts.findIndex(subPartItem => {
        return subPartItem.part.partName.replace(/ /g,"-").toLowerCase() === subPartName
      });
    }
    this.props.changeActivePartRelatedItemIndex(nextSubPartIndex);
    const parentSimple = (subPart.partName === "Floor" && subPart.partId !== "shower_floor")
      || subPart.partName === "Toilet"
      || (subPart.partName === "Ceiling" &&
        (document.kvConfig.visualizerType === "Bathroom" || document.kvConfig.visualizerType === "BV"))
      || subPart.partName === "Window";
    this.props.toggleSelectionWindow(true, parentSimple ? subPart.partName : subPart.getParent().partName);
    this.props.setCameFromPage('quote-design');
    if (layout.qtCategories) {
      changeQTRoutePath(parentName, nextSubPartIndex);
    } else {
      changeRoutePath(subPart.getParent ? subPart.getParent() : subPart, nextSubPartIndex, false);
    }
  };

  getBathroomHomeSections = () => {
    const layout = getCurrentLayout();
    let
      vanityItems = [],
      showerAndBathTubItems = [],
      otherItems = [];

    if (layout.qtCategories) {
      // console.log("parentParts", parentParts);
      return layout.qtCategories.map((qtCategory) => {
        return {
          title: qtCategory.name,
          // items: this.checkForWallsComplexGroup(qtCategory)
          items: qtCategory.subParts
        }
      });
    }

    layout.getFeatures().forEach((parentGroup) => {
      // console.log(partData);
      let subParts = parentGroup.subParts();
      if (parentGroup) {
        if (parentGroup.partName === "Vanity") {
          subParts.forEach((subPart) => {
            if (subPart.part.partId !== "accent_wall") {
              vanityItems.push(subPart)
            }
          });
        } else if (parentGroup.partName === "Shower") {
          subParts.forEach((subPart) => {
            showerAndBathTubItems.push(subPart)
          });
        } else if (parentGroup.partName === "Shower Tub Combo") {
          const excluded = ["wall_configuration", "shower_interior_wall", "shower_interior_wall_accent", "shower_fixture", "shower_door", "shower_door_handle"];
          subParts.forEach((subPart) => {
            if (!excluded.includes(subPart.part.partId)) {
              showerAndBathTubItems.push(subPart)
            }
          });
        } else if (parentGroup.partName === "Bathtub") {
          // console.log(parentGroup);
          if (parentGroup.bathTubBody) {
            showerAndBathTubItems.push({
              text: parentGroup.bathTubBody.partName,
              part: parentGroup.bathTubBody
            });
          }
          if (parentGroup.bathTubFixture) {
            showerAndBathTubItems.push({
              text: parentGroup.bathTubFixture.partName,
              part: parentGroup.bathTubFixture
            });
          }
        } else {
          subParts.forEach((subPart) => {
            if ((!subPart.part.partId.includes("wall") || subPart.part.partId === "wall_c")
              && subPart.part.partId !== "shower_fixture" && !subPart.part.disableOnHomeSections) {
              otherItems.push(subPart)
            }
          });
        }
      }
    });

    return [
      {
        title: <FormattedMessage id="projectScope.sectionsTitleVanities"/>,
        items: vanityItems,
      },
      {
        title: <FormattedMessage id="projectScope.sectionsTitleShowerAndBathtubs"/>,
        items: showerAndBathTubItems,
      },
      {
        title: <FormattedMessage id="projectScope.sectionsTitleMiscelaniousBathroom"/>,
        items: otherItems,
      },

    ]
  };

  getKitchenHomeSections = () => {
    const layout = getCurrentLayout();
    if (layout.qtCategories) {
      // console.log("parentParts", parentParts);
      return layout.qtCategories.map((qtCategory) => {
        return {
          title: qtCategory.name,
          // items: this.checkForWallsComplexGroup(qtCategory)
          items: qtCategory.subParts
        }
      });
    } else {
      const parentParts = layout.getFeatures();
      return parentParts.map((parentGroup) => {
        return {
          title: parentGroup.partName,
          items: parentGroup.subParts(false)
        }
      });
    }
  };

  getSections = () => {
    switch (document.kvConfig.visualizerType) {
      case "Kitchen":
      case "KV":
      case "kvMaster":
      case "kvScene":
      default:
        return this.getKitchenHomeSections();
      case "Bathroom":
      case "BV":
      case "bvScene":
      case "bvLook":
        return this.getBathroomHomeSections();
    }
  };

}
